module.exports = __webpack_public_path__ + "img/heart_bj.5f9f767b.png";